import headerBread from '@/components/header-breadcrumb.vue'


export default (Vue)=>{
  Vue.component("headerBread", headerBread)
}


// WEBPACK FOOTER //
// ./src/plugins/components.js